import { z } from 'zod'

export const AGENT_MANAGER_EXCEPTIONS_CONTRACT_VERSION = '1.0.0' as const

const passthroughResponseSchema = z.object({}).passthrough()

export const agentManagerHealthResponseSchema = passthroughResponseSchema
export const agentManagerProcessResultResponseSchema = passthroughResponseSchema

export type AgentManagerHealthResponse = z.infer<typeof agentManagerHealthResponseSchema>
export type AgentManagerProcessResultResponse = z.infer<typeof agentManagerProcessResultResponseSchema>
